import { TButtonTheme } from '@cian/ui-kit/button/types';

import { TNewbuildingEntryBannerType } from '../../../types/newbuildingEntryBanner';
import * as styles from './NewbuildingEntryBanner.css';

export const BUTTON_THEME_MAP = new Map<TNewbuildingEntryBannerType, TButtonTheme>([
  ['mixed', 'fill_primary'],
  ['mixed_promo', 'fill_primary'],
]);

export const CLASSES_THEME_MAP = new Map<TNewbuildingEntryBannerType, string>([
  ['mixed', styles['mixed']],
  ['mixed_promo', styles['mixed_promo']],
]);
